// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__IOTpM","col":"Table_col__3yjQx","fulfillmentStatus":"Table_fulfillmentStatus__IiCG3","emailCol":"Table_emailCol__21cuV"};